import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useProjectPromptTemplates = (config) => {
  return useQuery({
    ...config,
    queryKey: "project-prompt-templates",
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/messaging/project-prompt-templates`,
        signal,
      }),
  });
};

export const useProjectTemplates = (config) => {
  return useQuery({
    ...config,
    queryKey: "project-templates",
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/messaging/project-templates`,
        signal,
      }),
  });
};
